export default __webpack_public_path__ + "static/media/Union.b1a255c7.svg";